import { setToast } from '@/entities/toast'
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { getShiftsStopsFromRunsheets } from '../libs/getShiftsStopsFromRunsheets'
import { Runsheet } from '../models/runsheet/Runsheet'
import { upsertMultipleRunsheetShifts } from '../slices/runsheetShiftsSlice'
import { upsertMultipleRunsheets } from '../slices/runsheetsSlice'
import { upsertMultipleRunsheetStops } from '../slices/runsheetStopsSlice'

type FetchHistoricalRunsheetsPayload = {
  date: string
  dateRangeOption: 1 | 2 // 1 = single date, 2 = future 7 days
}

export const fetchHistoricalRunsheets = createAsyncThunk<void, FetchHistoricalRunsheetsPayload, ThunkApiContext>(
  'runsheets/fetchHistorical',
  async (payload, { dispatch }) => {
    const runsheets = await OLMSApiService.post<Runsheet[]>('/runsheet/search', payload)

    if (runsheets && runsheets.length === 0) {
      dispatch(setToast({
        open: true,
        severity: 'warning',
        title: 'No runsheets found',
        content: '0 runsheets found for the selected dates.',
      }))
    } else if (runsheets && runsheets.length > 0) {
      const { shifts, stops } = getShiftsStopsFromRunsheets(runsheets)

      dispatch(upsertMultipleRunsheetShifts(shifts))
      dispatch(upsertMultipleRunsheetStops(stops))

      const runsheetsWithoutShifts = runsheets.map(runsheet => {
        const { shifts: excludedShifts, ...rest } = runsheet

        return rest
      })

      dispatch(upsertMultipleRunsheets(runsheetsWithoutShifts))
    }
  })